import { Cross1Icon, DownloadIcon } from '@radix-ui/react-icons';
import { Box, Flex, IconButton, Text } from '@radix-ui/themes';
import React, { useRef, useState } from 'react';

interface DragAndDropFileUploadProps {
  onFileDrop: (file: File | null) => void;
  label?: string;
  accept?: string;
  selectedFile?: File | null;
  remove?: any
  isReadOnly?: boolean,
  disabled?: boolean
  required?: boolean;
}

export const DragAndDropFileUpload: React.FC<DragAndDropFileUploadProps> = ({ onFileDrop, label = "Arraste e solte o arquivo ou clique para selecionar", accept = "*", selectedFile, remove, isReadOnly = false, disabled = false }) => {
  const [dragging, setDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragging(true);
  };

  const getFileDownloadUrl = (file: File) => {
    return URL.createObjectURL(file);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      onFileDrop(file);
    }
  };

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onFileDrop(file);
    }
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleRemoveFile = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    onFileDrop(null);
    if (remove) {
      remove();
    }
  };
  return (
    <Box
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      onClick={handleClick}
      style={{
        padding: '20px',
        border: `2px dashed ${dragging ? '#000' : '#ccc'}`,
        borderRadius: '5px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'border-color 0.2s ease-in-out',
      }}
    >
      <input
        ref={fileInputRef}
        disabled={disabled}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
      {selectedFile ? (
        <Flex direction='row' gap='3'>
          <Text size="2">{selectedFile.name}</Text>
          <IconButton color="green" size='1' onClick={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
            const downloadUrl = getFileDownloadUrl(selectedFile);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = selectedFile.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
          }}>
            <DownloadIcon width="14" height="14" />
          </IconButton>
          {
            isReadOnly ? <></> :
              <IconButton color="red" size='1' onClick={handleRemoveFile} >
                <Cross1Icon width="14" height="14" />
              </IconButton>

          }
        </Flex>
      ) : (
        <Text size="2">
          {dragging ? 'Solte o arquivo aqui...' : label}
        </Text>
      )}
    </Box>
  );
};

